import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { cn } from '../utils/cn';
const faqs = [{
  question: 'Is this suitable for beginner instructors or only experienced ones?',
  answer: 'Stretching Ready was designed to work for instructors at every level. Whether you are just starting out or have years of experience, the six volumes take you from foundational full body sessions all the way through advanced themed programming. Each volume builds on the previous one, so you always have the right content for where you are right now.'
}, {
  question: 'Do I receive physical materials?',
  answer: 'Stretching Ready is a digital product delivered entirely in PDF format. You will receive instant access to all 6 volumes and 5 bonuses as downloadable files immediately after your purchase. No shipping, no waiting.'
}, {
  question: 'Can I read it on my phone or tablet?',
  answer: 'Absolutely. All PDFs are optimized to be read comfortably on any device — phone, tablet, laptop or desktop. You can also print any session you want to take to class with you.'
}, {
  question: 'Is this a theory course or a certification program?',
  answer: 'Neither. Stretching Ready is a done-for-you teaching system. There is no theory to study, no exam to pass and no certification attached. Every session is ready to open and teach immediately. This is a practical tool for working instructors, not a course.'
}, {
  question: 'Will this actually help me prepare sessions faster?',
  answer: 'That is the entire purpose. Every session in all 6 volumes is pre-structured with exact sequences, hold times, transitions and verbal cues. You open the volume, you teach the class. Most instructors report cutting their preparation time by more than half from the first week.'
}, {
  question: 'What is the 7-day guarantee?',
  answer: 'If for any reason you are not satisfied with Stretching Ready in the first 7 days after your purchase, simply contact us and we will issue a full refund — no questions asked. We are confident in the quality of this system, and we want you to feel completely safe making this investment.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-12 sm:py-24 bg-slate-50 relative overflow-hidden" data-id="element-50">
      {/* Decorative background */}
      <div className="absolute inset-0 bg-[radial-gradient(#e2e8f0_1px,transparent_1px)] [background-size:16px_16px] opacity-50" data-id="element-51" />

      <div className="relative mx-auto max-w-3xl px-4 sm:px-6 lg:px-8" data-id="element-52">
        <div className="text-center mb-8 sm:mb-16" data-id="element-53">
          <h2 className="text-2xl sm:text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl" data-id="element-54">
            FREQUENTLY ASKED QUESTIONS
          </h2>
        </div>

        <div className="space-y-3 sm:space-y-4" data-id="element-55">
          {faqs.map((faq, index) => <div key={index} className="rounded-xl sm:rounded-2xl bg-white ring-1 ring-slate-200 overflow-hidden hover:shadow-md transition-shadow" data-id="element-56">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="flex w-full items-center justify-between px-4 sm:px-6 py-4 sm:py-5 text-left focus:outline-none active:bg-slate-50 transition-colors" data-id="element-57">
                <span className="text-sm sm:text-base font-semibold text-slate-900 pr-4" data-id="element-58">
                  {faq.question}
                </span>
                <ChevronDown className={cn('h-4 w-4 sm:h-5 sm:w-5 text-slate-500 transition-transform duration-200 flex-shrink-0', openIndex === index && 'rotate-180')} data-id="element-59" />
              </button>
              <AnimatePresence data-id="element-60">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.2
            }} data-id="element-61">
                    <div className="px-4 sm:px-6 pb-4 sm:pb-5 text-sm sm:text-base text-slate-600 leading-relaxed" data-id="element-62">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}